import { render, staticRenderFns } from "./ConsultaSituacaoView.vue?vue&type=template&id=17a13b62&"
import script from "./ConsultaSituacaoView.vue?vue&type=script&lang=js&"
export * from "./ConsultaSituacaoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports